import React from 'react';
import { useAuth } from '../context/AuthContext';
import MainLayout from './MainLayout';
import Header from './Header';

const ConditionalLayout = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-gray dark:bg-dark-bg">
        <div className="spinner"></div>
      </div>
    );
  }

  // If user is logged in, show sidebar layout
  if (user) {
    return <MainLayout>{children}</MainLayout>;
  }

  // If not logged in, show header layout
  return (
    <>
      <Header />
      <div className="pt-16">{children}</div>
    </>
  );
};

export default ConditionalLayout;
